import { render, staticRenderFns } from "./CraftForm.vue?vue&type=template&id=f9a4209c&scoped=true&"
import script from "./CraftForm.vue?vue&type=script&lang=js&"
export * from "./CraftForm.vue?vue&type=script&lang=js&"
import style0 from "./CraftForm.vue?vue&type=style&index=0&id=f9a4209c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a4209c",
  null
  
)

export default component.exports